import { useContext } from "react";
import {
  ActiveProjectService,
  type UseActiveProjectService,
} from "src/services/useActiveProject.service";

type UseActiveProject = UseActiveProjectService;

export const useActiveProject = () => useContext<UseActiveProject>(ActiveProjectService);
